import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {

  constructor(private csObj:CommonService) { }

  ngOnInit(): void {
  }

  onClickPP(){
    this.csObj.agreeCheck.next(1);
  }

}
